export const getClientBanner = (
  collectiveAgreement?: string,
  collectiveAgreementLabel?: string,
  clientSize?: string,
  clientSizeLabel?: string,
  sectorLabel?: string,
  sector?: string,
  location?: string,
  locationLabel?: string,
) => {
  return [
    { label: locationLabel, value: location },
    { label: sectorLabel, value: sector },
    { label: clientSizeLabel, value: clientSize },
    {
      label: collectiveAgreementLabel,
      value: collectiveAgreement,
    },
  ];
};
